export const getBirthdayFromIIN = (iin) => {
  if (iin.length !== 12) {
    return;
  }
  const birthday = iin.slice(0, 6);

  const day = birthday.slice(4, 6);
  const month = birthday.slice(2, 4);
  const year = birthday.slice(0, 2);

  const num = iin[6];
  let century = '';

  if (['1', '2'].includes(num)) {
    century = '18';
  } else if (['3', '4'].includes(num)) {
    century = '19';
  } else if (['5', '6'].includes(num)) {
    century = '20';
  } else if (['0'].includes(num)) {
    century = '19';
  }

  return `${century}${year}-${month}-${day}`;
};
